/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<e491498af38568ea185bd8d6239269d3>>
 * @relayHash 821f18f68326a0288e97e5f7d8f33df5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec6025ad49b080db5bfaad8ef37cdbc65862d2d5cc2a21cf9890378347c95f71

import type { ConcreteRequest, Query } from 'relay-runtime';
export type helpCenterAuthProviderQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type helpCenterAuthProviderQuery$data = {
  readonly helpLayout: {
    readonly mediaConfig: {
      readonly asapIssuer: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  } | null | undefined;
};
export type helpCenterAuthProviderQuery = {
  response: helpCenterAuthProviderQuery$data;
  variables: helpCenterAuthProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "parentAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaToken",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asapIssuer",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "helpCenterAuthProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "HelpLayoutMediaConfig",
              "kind": "LinkedField",
              "name": "mediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v4/*: any*/),
                  "action": "THROW",
                  "path": "helpLayout.mediaConfig.mediaToken"
                },
                {
                  "kind": "RequiredField",
                  "field": (v5/*: any*/),
                  "action": "THROW",
                  "path": "helpLayout.mediaConfig.mediaUrl"
                },
                {
                  "kind": "RequiredField",
                  "field": (v6/*: any*/),
                  "action": "THROW",
                  "path": "helpLayout.mediaConfig.asapIssuer"
                }
              ],
              "storageKey": null
            },
            "action": "THROW",
            "path": "helpLayout.mediaConfig"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "helpCenterAuthProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "HelpLayoutMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ec6025ad49b080db5bfaad8ef37cdbc65862d2d5cc2a21cf9890378347c95f71",
    "metadata": {},
    "name": "helpCenterAuthProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8d55388dabe06015bee0ae2811adc84a";

export default node;
